import { render, staticRenderFns } from "./Yandex.vue?vue&type=template&id=4a31b767&scoped=true&"
import script from "./Yandex.vue?vue&type=script&lang=js&"
export * from "./Yandex.vue?vue&type=script&lang=js&"
import style0 from "./Yandex.vue?vue&type=style&index=0&id=4a31b767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a31b767",
  null
  
)

export default component.exports